export var getStyles = function (props) {
    var theme = props.theme, className = props.className, enableShimmer = props.enableShimmer;
    var palette = theme.palette;
    return {
        root: [
            enableShimmer && {
                selectors: {
                    ':after': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        backgroundImage: "linear-gradient(to bottom, transparent 30%, " + palette.whiteTranslucent40 + " 65%," + palette.white + " 100%)"
                    }
                }
            },
            className
        ]
    };
};
//# sourceMappingURL=ShimmeredDetailsList.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/DetailsList/ShimmeredDetailsList.styles.js
// module id = 768
// module chunks = 0